// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YyOy","label":"styles_label__I-p22"};